module.exports = __webpack_public_path__ + "static/media/icon-user-nopic.ecca47c3.svg";